var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.1875H31V5.8125H0V25.1875ZM15.5 9.6875C18.7104 9.6875 21.3125 12.2896 21.3125 15.5C21.3125 18.7104 18.7104 21.3125 15.5 21.3125C12.2896 21.3125 9.6875 18.7104 9.6875 15.5C9.6875 12.2896 12.2896 9.6875 15.5 9.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillCash);
export default __webpack_public_path__ + "static/media/bill_cash.bb3c696c.svg";
export { ForwardRef as ReactComponent };